import React from 'react';
import { render } from 'react-dom';

import PackageCta from '../react/PackageCta';

export default class PackageCtaRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model, tourKey, abandonBasketApi } = this.context.dataset;
    if (!tourKey || !model || !abandonBasketApi) throw Error('Missing a required dataset');

    let jsonModel;
    try {
      jsonModel = JSON.parse(model);
    } catch (e) {
      jsonModel = undefined;
      console.error('Error parsing labels json: ', model);
    }

    render(
      <PackageCta {...jsonModel} tourKey={tourKey} abandonBasketApi={abandonBasketApi} />,
      this.context
    );
  }
}
